import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProfilesAccordion } from "src/components/profiles-accordion";

interface Props {
  open: boolean;
  onClose: () => void;
  onCreate?: () => void;
  partnerProfiles: any[]; // Replace `any` with the actual type
  checkboxStates: any; // Replace with your type
  handleCheckboxChange: (id: number) => void; // Adjust type based on your logic
}

export default function NewRoleDialog({
  open,
  onClose,
  onCreate,
  partnerProfiles,
  checkboxStates,
  handleCheckboxChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <Dialog maxWidth="md" open={open} scroll="body">
      <DialogTitle>{t("create_new_profiles")}</DialogTitle>
      <DialogContent>
        {partnerProfiles.map((partnerProfile, index) => (
          <ProfilesAccordion
            key={partnerProfile.id}
            profile={partnerProfile}
            index={index}
            checkboxStates={checkboxStates}
            handleCheckboxChange={handleCheckboxChange}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button onClick={onClose} variant="outlined" color="inherit">
              {t("cancel")}
            </Button>
          </Grid>

          <Grid item textAlign={"right"} xs={6}>
            <Button
              onClick={onCreate}
              variant="contained"
              color="secondary"
              size="medium"
            >
              {t("create")}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
